import React, { useEffect, useState, useCallback, Fragment } from 'react';
import propTypes from 'prop-types';
import { Dropdown, Label } from '@tcc/crate';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import { getMessage } from 'util/locale';

export const CropProtectionDropdown = ({
  allProducts,
  createCustomChemical,
  disabled,
  dropdownLabel,
  isEditRoute,
  isFieldOwner,
  onSetValue,
  products,
  selectedProduct,
  substanceTypeUuid,
  chemicalTypeIds
}) => {
  const [state, setState] = useState({
    isLoading: false,
    sortedOptions: [],
    searchDefaultOption: undefined
  });
  useEffect(() => {
    if (products) {
      const uniqOptions = uniqBy(products, 'id');
      const sortedOptions = uniqOptions
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(el => ({ value: el.name, id: el.id, description: el.company }));
      setState(state => ({...state, sortedOptions }));
    }

  }, [products]);

  const setValue = useCallback((val, id) => {
    if (id === 'custom-id') {
      createCustomChemical({
        chemicalName: val,
        substanceId: substanceTypeUuid,
        chemicalTypeIds
      });

      setState(state => ({ ...state, searchDefaultOption: undefined }));
    } else {
      onSetValue(id, isEditRoute, products);
    }
  }, [isEditRoute, products]);

  function searchFilter(input, substanceType) {
    const anyOption = allProducts.find(option => {
      return option.name.toLowerCase().includes(input.trim().toLowerCase());
    });

    if (!anyOption && isFieldOwner) {
      const newCrop = {
        value: input,
        id: 'custom-id',
        listDisplayText: getMessage('text__use-custom-crop-protection', { chemName: input, type: substanceType }),
        isCustom: true
      };

      setState(state => ({ ...state, searchDefaultOption: newCrop}));
    } else if (state.searchDefaultOption) {
      setState(state => ({ ...state, searchDefaultOption: undefined}));
    }
  }

  let customLabelEnabled = false;
  if (selectedProduct && products && products.length) {
    const productObj = products.find(product => product.id === selectedProduct.id);
    customLabelEnabled = productObj && productObj.isCustom;
  }

  return (
    <Fragment>
      <div data-test-id="crop-protection-product">
        <Dropdown
          disabled={disabled}
          isLoading={state.isLoading}
          label={dropdownLabel}
          onSearchFilter={e => searchFilter(e, substanceTypeUuid)}
          options={state.sortedOptions}
          searchDefaultOption={state.searchDefaultOption}
          searchable
          selectedId={state.isLoading ? undefined : get(selectedProduct, 'id')}
          setValue={setValue}
          value={state.isLoading ? get(selectedProduct, 'name') : undefined}
        />
        {customLabelEnabled
          ? <Label
            className='custom-chemical-inline-badge'
            status='default'
            testId='crate-label-success-primary'>
            {getMessage('text__use-custom-label-abbrev')}
          </Label> : null}
      </div>
    </Fragment>
  );
};

CropProtectionDropdown.propTypes = {
  allProducts: propTypes.array,
  chemicalTypeIds: propTypes.object,
  createCustomChemical: propTypes.func.isRequired,
  disabled: propTypes.bool,
  dropdownLabel: propTypes.string,
  isEditRoute: propTypes.bool.isRequired,
  isFieldOwner: propTypes.bool,
  onSetValue: propTypes.func.isRequired,
  products: propTypes.array,
  selectedId: propTypes.string,
  selectedProduct: propTypes.object,
  substanceTypeUuid: propTypes.string
};
